import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

import { pointerEventsStyles, COLORS, ELEVATIONS } from '@garnish/constants';

import { Icon } from '../../Icon';

export const ButtonCenterLocation = (props: ButtonCenterLocationProps) => {
  const {
    onPress,
    disabled,
    style,
    accessibilityLabel = DEFAULT_A11Y_LABEL,
    accessibilityHint = DEFAULT_A11Y_HINT,
    withTransparentBackground,
    ...wrapperProps
  } = props;

  const buttonStyles = [
    styles.button,
    withTransparentBackground ? styles.buttonUpdate : styles.buttonLegacy,
  ];
  const iconColor = disabled ? COLORS.OPACITY.DARK_KALE.LIGHT : COLORS.TEXT_COLOR;

  return (
    <View {...wrapperProps} style={[styles.wrapper, style]}>
      <TouchableOpacity
        activeOpacity={ACTIVE_OPACITY}
        accessibilityRole="button"
        accessibilityLabel={accessibilityLabel}
        accessibilityHint={accessibilityHint}
        accessibilityState={{ disabled: Boolean(disabled), busy: false }}
        style={buttonStyles}
        disabled={disabled}
        onPress={onPress}
      >
        <Icon
          name="IconTarget"
          width={ICON_SIZE}
          height={ICON_SIZE}
          color={iconColor}
          style={pointerEventsStyles.none}
        />
      </TouchableOpacity>
    </View>
  );
};

export const DEFAULT_A11Y_LABEL = 'Center map';
export const DEFAULT_A11Y_HINT = 'Centers map to user location';

//
// ─── CONSTANTS ──────────────────────────────────────────────────────────────────
//

const ACTIVE_OPACITY = 0.8;
const ICON_SIZE = 24;

//
// ─── STYLES ─────────────────────────────────────────────────────────────────────
//

const styles = StyleSheet.create({
  wrapper: {
    width: 40,
  },
  button: {
    height: 40,
    borderRadius: 40,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonLegacy: {
    ...ELEVATIONS['8'],
    backgroundColor: COLORS.CREAM,
  },
  buttonUpdate: {
    backgroundColor: COLORS.OPACITY.TRANSPARENT,
  },
});

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type ButtonCenterLocationProps = {
  onPress?: () => void;
  disabled?: boolean;
  withTransparentBackground?: boolean;
} & ViewProps;
